export default "__VITE_ASSET__Dm2g_bYB__"